// API URLs
export const RELAYER_URL = 'https://relayer-v2.polymarket.com/'
export const RELAYER_FALLBACK_URL = 'https://chance-relayer-production.up.railway.app/'
// Use proxy in browser to avoid Cloudflare blocking, direct URL on server
export const CLOB_API_URL = 'https://polymarket-clob.pzp.money'

export const POLYMARKET_PROFILE_URL = (address: string) => `https://polymarket.com/${address}`

// RPC URLs
export const POLYGON_RPC_URL = process.env.NEXT_PUBLIC_POLYGON_RPC_URL || 'https://polygon-rpc.com'

// Remote signing
export const REMOTE_SIGNING_URL = () =>
	typeof window !== 'undefined'
		? `${window.location.origin}/api/polymarket/trading`
		: '/api/polymarket/trading'

// Other constants
export const POLYGON_CHAIN_ID = 137
export const SESSION_STORAGE_KEY = 'polymarket_trading_session'
